import React, { useEffect, useState } from "react";
import { Card, Col, Nav, Tab } from "react-bootstrap";
import { Helmet } from "react-helmet";
import {
    Link,
    useLocation,
    useNavigate,
    useSearchParams,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import { findMatchingPath } from "../../utils/helper";
import { HEADER_TITLE_DEFAULT } from "../../data/StaticData";
import Accounts from "./Accounts";
import Transaction from "./Transaction";
import Creditors from "./Creditors";



const Bank = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { userPermission } = useSelector(selectUser);
    const [matchingPathObject, setMatchingPathObject] = useState(null);
    const activeTab = searchParams.get("tab") || "0";

    useEffect(() => {
        if (userPermission) {
            const result = findMatchingPath(userPermission, pathname);
            setMatchingPathObject(result);
            if (!searchParams.get("tab")) {
                navigate(`?tab=0`, { replace: true });
            }
        }
    }, [userPermission, pathname, searchParams, navigate]);

    // Tab rows are looked up by `route` (module_of_sub_modules under Bank
    // Management: bank-accounts / user-accounts / bank-transaction, seeded by
    // _fix_bank_leaves_2026-09-08.js). Before that fix the page read the
    // first two rows by position, which were the legacy "Expense …" API-gate
    // leaves — kept as a fallback so an environment without the new rows
    // behaves exactly as before.
    const leaves = matchingPathObject?.modulesOfSubModule || [];
    const leafByRoute = (route) => leaves.find((l) => l.route === route);
    const bankAccountsPermission = leafByRoute("bank-accounts") || leaves[0];
    const userAccountsPermission = leafByRoute("user-accounts") || bankAccountsPermission;
    const transactionPermission = leafByRoute("bank-transaction") || leaves[1];

    const TABS = [
        {
            title: "Accounts",
            component: Accounts,
            eventKey: "0",
            permission: bankAccountsPermission,
            extraProps: { userAccountsPermission },
            // hide only when BOTH sub-tabs are explicitly un-viewable
            visible:
                !(bankAccountsPermission && userAccountsPermission) ||
                bankAccountsPermission?.view == 1 ||
                userAccountsPermission?.view == 1,
        },
        {
            title: "Transaction",
            component: Transaction,
            eventKey: "1",
            permission: transactionPermission,
            extraProps: {},
            visible: !transactionPermission || transactionPermission?.view == 1,
        },
    ].filter((tab) => tab.visible);

    return (
        <>
            <Helmet>
                <title>Bank Management · {HEADER_TITLE_DEFAULT}</title>
            </Helmet>
            <Col md={12} data-aos={"fade-up"}>
                <Card className="card-bg p-2">
                    <Tab.Container id="tabs" activeKey={activeTab}>
                        <Nav variant="pills">
                            {TABS?.map(({ title, eventKey }) => (
                                <Nav.Item key={eventKey}>
                                    <Nav.Link
                                        as={Link}
                                        to={`?tab=${eventKey}`}
                                        eventKey={eventKey}
                                    >
                                        {title}
                                    </Nav.Link>
                                </Nav.Item>
                            ))}
                        </Nav>

                        <Tab.Content className="mt-3">
                            {TABS?.map(({ component: Component, eventKey, permission, extraProps }) => (
                                <Tab.Pane key={eventKey} eventKey={eventKey}>
                                    {eventKey == activeTab ? (
                                        <Component checkPermission={permission} {...extraProps} />
                                    ) : (
                                        ""
                                    )}
                                </Tab.Pane>
                            ))}
                        </Tab.Content>
                    </Tab.Container>
                </Card>
            </Col>
        </>
    );
};

export default Bank;
